// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-notification-overlay,
.app-confirm-overlay {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  background: rgba(15, 23, 42, 0.35);
  z-index: 60;
}

.app-notification-panel,
.app-confirm-panel {
  background: var(--surface-color);
  color: #0f172a;
  border-radius: 16px;
  border: 1px solid rgba(148, 163, 184, 0.4);
  padding: 1.05rem 1.2rem;
  max-width: 520px;
  width: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
  box-shadow: none;
}

.app-notification-panel {
  text-align: center;
}

.app-dialog-head {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  margin-bottom: 0.65rem;
  text-align: center;
}

.app-dialog-label {
  font-size: 0.7rem;
  text-transform: uppercase;
  letter-spacing: 0.18em;
  color: rgba(15, 23, 42, 0.55);
  margin: 0;
}

.app-dialog-title {
  margin: 0;
  font-size: 1.15rem;
  color: #0f172a;
}

.app-notification-content {
  font-size: 0.95rem;
  line-height: 1.45;
  margin-bottom: 0.9rem;
  text-align: left;
  flex: 1 1;
}

.app-notification-content p {
  margin: 0.45rem 0;
}

.app-notification-close-btn {
  border: 1px solid #d1d5db;
  border-radius: 10px;
  background: #e5e7eb;
  color: #1f2937;
  font-size: 0.82rem;
  font-weight: 600;
  padding: 0.4rem 1rem;
  min-width: 86px;
  cursor: pointer;
  transition: background 0.2s ease, transform 0.2s ease;
}

.app-notification-close-btn:hover {
  background: #d1d5db;
  transform: translateY(-1px);
}

.app-confirm-content {
  font-size: 0.95rem;
  line-height: 1.45;
  margin-bottom: 0.95rem;
  text-align: left;
  flex: 1 1;
}

.app-confirm-content p {
  margin: 0.4rem 0;
}

.app-dialog-actions,
.app-confirm-actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  flex-wrap: wrap;
  margin-top: auto;
}

.app-dialog-actions.single {
  justify-content: flex-end;
}

.app-confirm-btn {
  border-radius: 10px;
  padding: 0.4rem 1rem;
  font-size: 0.82rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s ease, transform 0.2s ease, color 0.2s ease;
  min-width: 86px;
}

.app-confirm-btn.secondary {
  border: 1px solid rgba(148, 163, 184, 0.6);
  background: #f8fafc;
  color: #1f2937;
}

.app-confirm-btn.secondary:hover {
  background: #e2e8f0;
  transform: translateY(-1px);
}

.app-confirm-btn.primary {
  border: none;
  background: #e5e7eb;
  color: #1f2937;
}

.app-confirm-btn.primary:hover {
  background: #d1d5db;
  transform: translateY(-1px);
}

.App.dark .app-notification-panel,
.App.dark .app-confirm-panel {
  background: #1c2630;
  color: #e5e7eb;
  border-color: #263447;
  box-shadow: none;
}

.App.dark .app-notification-close-btn {
  background: #374151;
  border-color: #4b5563;
  color: #f8fafc;
}

.App.dark .app-dialog-label {
  color: rgba(226, 232, 240, 0.65);
}

.App.dark .app-dialog-title {
  color: #f1f5f9;
}

.App.dark .app-confirm-btn.secondary {
  border: 1px solid rgba(148, 163, 184, 0.4);
  background: rgba(30, 41, 59, 0.9);
  color: #e5e7eb;
}

.App.dark .app-confirm-btn.secondary:hover {
  background: rgba(51, 65, 85, 1);
}

.App.dark .app-confirm-btn.primary {
  background: #374151;
  color: #f8fafc;
}

@media (max-width: 768px) {
  .app-notification-overlay,
  .app-confirm-overlay {
    padding: 0.7rem;
  }

  .app-notification-panel,
  .app-confirm-panel {
    max-width: 100%;
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/dialogs/DialogBase.css"],"names":[],"mappings":"AAAA;;EAEE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kCAAkC;EAClC,WAAW;AACb;;AAEA;;EAEE,gCAAgC;EAChC,cAAc;EACd,mBAAmB;EACnB,0CAA0C;EAC1C,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,6BAA6B;EAC7B,SAAS;AACX;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,eAAe;EACf,qDAAqD;AACvD;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,sEAAsE;EACtE,eAAe;AACjB;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE;;IAEE,eAAe;EACjB;;EAEA;;IAEE,eAAe;IACf,WAAW;EACb;AACF","sourcesContent":[".app-notification-overlay,\n.app-confirm-overlay {\n  position: fixed;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1rem;\n  background: rgba(15, 23, 42, 0.35);\n  z-index: 60;\n}\n\n.app-notification-panel,\n.app-confirm-panel {\n  background: var(--surface-color);\n  color: #0f172a;\n  border-radius: 16px;\n  border: 1px solid rgba(148, 163, 184, 0.4);\n  padding: 1.05rem 1.2rem;\n  max-width: 520px;\n  width: 100%;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  box-shadow: none;\n}\n\n.app-notification-panel {\n  text-align: center;\n}\n\n.app-dialog-head {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n  margin-bottom: 0.65rem;\n  text-align: center;\n}\n\n.app-dialog-label {\n  font-size: 0.7rem;\n  text-transform: uppercase;\n  letter-spacing: 0.18em;\n  color: rgba(15, 23, 42, 0.55);\n  margin: 0;\n}\n\n.app-dialog-title {\n  margin: 0;\n  font-size: 1.15rem;\n  color: #0f172a;\n}\n\n.app-notification-content {\n  font-size: 0.95rem;\n  line-height: 1.45;\n  margin-bottom: 0.9rem;\n  text-align: left;\n  flex: 1;\n}\n\n.app-notification-content p {\n  margin: 0.45rem 0;\n}\n\n.app-notification-close-btn {\n  border: 1px solid #d1d5db;\n  border-radius: 10px;\n  background: #e5e7eb;\n  color: #1f2937;\n  font-size: 0.82rem;\n  font-weight: 600;\n  padding: 0.4rem 1rem;\n  min-width: 86px;\n  cursor: pointer;\n  transition: background 0.2s ease, transform 0.2s ease;\n}\n\n.app-notification-close-btn:hover {\n  background: #d1d5db;\n  transform: translateY(-1px);\n}\n\n.app-confirm-content {\n  font-size: 0.95rem;\n  line-height: 1.45;\n  margin-bottom: 0.95rem;\n  text-align: left;\n  flex: 1;\n}\n\n.app-confirm-content p {\n  margin: 0.4rem 0;\n}\n\n.app-dialog-actions,\n.app-confirm-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.5rem;\n  flex-wrap: wrap;\n  margin-top: auto;\n}\n\n.app-dialog-actions.single {\n  justify-content: flex-end;\n}\n\n.app-confirm-btn {\n  border-radius: 10px;\n  padding: 0.4rem 1rem;\n  font-size: 0.82rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.2s ease, transform 0.2s ease, color 0.2s ease;\n  min-width: 86px;\n}\n\n.app-confirm-btn.secondary {\n  border: 1px solid rgba(148, 163, 184, 0.6);\n  background: #f8fafc;\n  color: #1f2937;\n}\n\n.app-confirm-btn.secondary:hover {\n  background: #e2e8f0;\n  transform: translateY(-1px);\n}\n\n.app-confirm-btn.primary {\n  border: none;\n  background: #e5e7eb;\n  color: #1f2937;\n}\n\n.app-confirm-btn.primary:hover {\n  background: #d1d5db;\n  transform: translateY(-1px);\n}\n\n.App.dark .app-notification-panel,\n.App.dark .app-confirm-panel {\n  background: #1c2630;\n  color: #e5e7eb;\n  border-color: #263447;\n  box-shadow: none;\n}\n\n.App.dark .app-notification-close-btn {\n  background: #374151;\n  border-color: #4b5563;\n  color: #f8fafc;\n}\n\n.App.dark .app-dialog-label {\n  color: rgba(226, 232, 240, 0.65);\n}\n\n.App.dark .app-dialog-title {\n  color: #f1f5f9;\n}\n\n.App.dark .app-confirm-btn.secondary {\n  border: 1px solid rgba(148, 163, 184, 0.4);\n  background: rgba(30, 41, 59, 0.9);\n  color: #e5e7eb;\n}\n\n.App.dark .app-confirm-btn.secondary:hover {\n  background: rgba(51, 65, 85, 1);\n}\n\n.App.dark .app-confirm-btn.primary {\n  background: #374151;\n  color: #f8fafc;\n}\n\n@media (max-width: 768px) {\n  .app-notification-overlay,\n  .app-confirm-overlay {\n    padding: 0.7rem;\n  }\n\n  .app-notification-panel,\n  .app-confirm-panel {\n    max-width: 100%;\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
